var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
import Icon from './wrappers/ReUpIcon';
var ArcMeter = require('./ArcMeter.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  
  StyleSheet,
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKButton,
} = MK;

var RewardsList = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
      didSelectReward : function(reward){},
      rewards : [],
      numUserPoints : 0,
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      value:0,
    }
  },

  componentDidMount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  doTransaction: function()
  {
    this.props.appActions.requestFeatureName("TransactionResult");
  },

  numSelected: function(i)
  {
    var newValue = this.state.value * 10 + i;
    if( this.stringDollarValue(newValue).length > 11 ) return; // some sort of max
    this.valueChanged(newValue);

    this.setState({value:newValue});
  },

  deleteSelected: function()
  {
    var newValue = Math.floor(this.state.value / 10);
    this.valueChanged(newValue);

    this.setState({value:newValue});
  },

  stringDollarValue: function(value)
  {
    if( typeof value === 'undefined' ) value = this.state.value;

    return this.props.appManager.getLocalizationManager().localizedDollars(parseFloat(value)/100);
  },

  stringPointValue: function(value)
  {
    value = this.pointsAmount(value);

    var points = this.props.appManager.getLocalizationManager().localizedPoints(value);
    if( points.length > 12 )
    {
      points = this.props.appManager.getLocalizationManager().localizedPts(value);
    }

    return points;
  },

  stringValue: function(value)
  {
    if( this.props.isDollars )
    {
      return this.stringDollarValue(value);
    }
    else
    {
      return this.stringPointValue(value);
    }
  },

  clearSelected: function()
  {
    var newValue = 0;
    this.valueChanged(newValue);

    this.setState({value:newValue});
  },

  valueChanged: function(newValue)
  {
    if( this.props.isDollars )
    {
      this.props.valueChanged(newValue, this.stringValue(newValue));
    }
    else if( this.props.isCheckin )
    {
      this.props.valueChanged(newValue, this.stringPointValue(newValue));
    }
    else
    {
      this.props.valueChanged(newValue);
    }
  },

  pointsAmount: function(value)
  {
    if( typeof value === 'undefined' ) value = this.state.value;

    return Math.floor(value/(100 * this.props.pointsPerDollar) )
  },

  dollarsAmount: function(value)
  {
    if( typeof value === 'undefined' ) value = this.state.value;

    return parseFloat(value)/100;
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;

    var rowStyle = {flexDirection:'row',flex:1};
    var numSelected = thisThing.numSelected;
    var clearSelected = thisThing.clearSelected;
    var deleteSelected = thisThing.deleteSelected;
    var appManager = this.props.appManager;
    var rewards = this.props.rewards;
    var numUserPoints = this.props.numUserPoints;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");

    return (
      <View style={this.props.style}>
      {
        rewards.map(function(reward, index)
        {
          if( typeof reward.Points == 'undefined' ) reward.Points = 0;

          var afforded = parseInt(numUserPoints) >= parseInt(reward.Points);
          if( reward.IsDeleted == "1" ) return <View key={reward.RewardID} />
          var fraction = Math.min(1,parseFloat(reward.Points) <= 0 ? 1 : parseFloat(numUserPoints)/parseFloat(reward.Points));
          var amountFontSize = 30 - ((reward.Points + "").length > 3 ? ((reward.Points + "").length - 3)*5 : 0);
          var name = reward.RewardName;
          if( typeof reward.others !== 'undefined' && reward.others.length > 0 ) name += " ("+(reward.others.length+1)+")";
          return (
            <ReUpButton key={reward.RewardID} appManager={appManager} isTertiary={true}
              icon={'angle-right'} iconColor={'red'}
              maskBorderRadius={0}
              enabled={afforded}
              style={{backgroundColor: 'transparent', padding: 0, alignSelf:'stretch', margin:0, width:-1, height:-1}}
              onPress={()=>{thisThing.props.didSelectReward(reward);}}
            >
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignItems:'center'}}>
                <View style={{margin:5, width:110, height:110, alignItems:'center', justifyContent:'center'}}>
                  <ArcMeter fgColor={profileMeterColor} bgColor={profileMeterBackgroundColor} percentage={fraction} style={{width:100,height:100}}>
                    <View>
                      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.rewardAmount,{fontSize:amountFontSize, color:generalTitleColor}]}>
                        {reward.Points}
                      </ReUpText>
                    </View>
                  </ArcMeter>
                </View>
                <View style={{marginRight:20, flex:1, flexDirection:'column'}}>
                  <View>
                    <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor}]}>
                      {name}
                    </ReUpText>
                  </View>
                  <View style={{height:4}} />
                  <View>
                    <ReUpText appManager={appManager} style={{color:generalTitleColor}}>
                      {reward.Description}
                    </ReUpText>
                  </View>
                </View>
              </View>
            </View>
            <View style={{
              height:1,
              position:'absolute',
              left:0, right:0, bottom:0,
              backgroundColor:'#DADADA'
            }}/>
            </ReUpButton>)
        })
      }
      </View>
    );
  }
});

var styles = StyleSheet.create({
  rewardAmountContainer: {
    width:80,
    height:80,
    borderRadius:40,
    borderWidth:8,
    margin:10,
    justifyContent:'center',
    alignItems:'center',
    alignSelf:'center',
    flex:1,
  },
  rewardAmount: {
    fontSize:34,
    alignSelf:'center',
    justifyContent:'center',
  },
  rewardRightContainer: {
    flex:1,
    justifyContent:'center',
    paddingRight:8,
    paddingBottom:4,
    paddingTop:4
  },
  rewardDescription: {
    padding:0,
    margin:0,
    opacity:.8,
  }

});

module.exports = RewardsList;



// WEBPACK FOOTER //
// ./src/RewardsList.js